module.exports = __webpack_public_path__ + "img/icon_top_msg@2x.7e5127c1.png";